import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/waiting')({
  beforeLoad: () => {
    throw redirect({ to: '/tasks/waiting' });
  },
});
